import { render, staticRenderFns } from "./cancerHallmark.vue?vue&type=template&id=1f112cb6&"
import script from "./cancerHallmark.vue?vue&type=script&lang=js&"
export * from "./cancerHallmark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports